import { sha256 } from 'js-sha256'

export const hashEmail = (email?: string | null) => (email ? sha256(email.toLowerCase().trim()) : undefined)

/** Trims and lowercases before hashing, as ad platforms expect. Blank and null both give undefined. */
export const hashPii = (value?: string | null) => {
  const normalised = value?.trim().toLowerCase()
  return normalised ? sha256(normalised) : undefined
}

/**
 * Also strips non-alphanumerics, for names and locality fields: "SW1A 1AA" and "sw1a1aa" must hash
 * the same or the platform never matches them.
 */
export const hashPiiCompact = (value?: string | null) => {
  const normalised = value
    ?.trim()
    .toLowerCase()
    .replace(/[^a-z0-9]/g, '')
  return normalised ? sha256(normalised) : undefined
}

/**
 * Derives a deterministic UUID from `seed` by formatting a SHA-256 hash into the
 * UUID layout with valid version (5) and variant nibbles. Useful where an API
 * requires `format: uuid` but the value must be reproducible from its inputs
 * (e.g. idempotency keys).
 */
export const getDeterministicUuid = (seed: string): string => {
  const hex = sha256(seed)
  const variant = ((parseInt(hex[16], 16) & 0x3) | 0x8).toString(16)
  return [
    hex.slice(0, 8),
    hex.slice(8, 12),
    `5${hex.slice(13, 16)}`,
    `${variant}${hex.slice(17, 20)}`,
    hex.slice(20, 32),
  ].join('-')
}
